import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
interface CTASectionProps {
  title: string;
  description: string;
  primaryCtaText: string;
  secondaryCtaText?: string;
  onPrimaryClick: () => void;
  onSecondaryClick?: () => void;
}
export function CTASection({
  title,
  description,
  primaryCtaText,
  secondaryCtaText,
  onPrimaryClick,
  onSecondaryClick
}: CTASectionProps) {
  return <section className="py-20 lg:py-32" data-id="element-57">
      <div className="container mx-auto px-4 md:px-6" data-id="element-58">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 px-6 py-16 text-center shadow-2xl sm:px-16 sm:py-24" data-id="element-59">
          {/* Abstract Shapes */}
          <div className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl" data-id="element-60"></div>
          <div className="absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2 w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl" data-id="element-61"></div>

          <div className="relative z-10 max-w-3xl mx-auto space-y-8" data-id="element-62">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl" data-id="element-63">
              {title}
            </h2>
            <p className="mx-auto max-w-2xl text-lg text-blue-100/90 md:text-xl leading-relaxed" data-id="element-64">
              {description}
            </p>
            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row pt-4" data-id="element-65">
              <Button size="lg" variant="default" onClick={onPrimaryClick} className="w-full sm:w-auto font-semibold !bg-white !text-blue-900 hover:!bg-blue-50 hover:!text-blue-900 shadow-lg !border-0 h-14 px-8 text-lg transition-all duration-300" data-id="element-66">
                {primaryCtaText} <ArrowRight className="ml-2 h-5 w-5" data-id="element-67" />
              </Button>
              {secondaryCtaText && <Button size="lg" variant="outline" onClick={onSecondaryClick} className="w-full sm:w-auto !bg-transparent !text-white !border-white/30 hover:!bg-white/10 hover:!text-white hover:!border-white h-14 px-8 text-lg transition-all duration-300" data-id="element-68">
                  {secondaryCtaText}
                </Button>}
            </div>
            <p className="text-sm text-blue-200/60 pt-4" data-id="element-69">
              Kostenlos registrieren • Keine Kreditkarte erforderlich •
              Jederzeit kündbar
            </p>
          </div>
        </div>
      </div>
    </section>;
}